import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Language } from '../../app/common/constants';
import ApplySign from '../controls/applySign';
import { disclaimerEN, disclaimerSP } from './services/disclaimer';
import './css/concent.css';
import { Sign } from 'crypto';

function Disclaimer(props) {
    const [language, setLanguage] = useState("English");
    const [concent, setConcent] = useState(disclaimerEN);

    useEffect(() => {
        if (props.language) {
            setLanguage(props.language);
        }
    }, [props.language]);

    useEffect(() => {
        if (language === Language.SPANISH) {
            setConcent(disclaimerSP);
        }
        else {
            setConcent(disclaimerEN);
        }
    }, [language]);

    const onSigned = (value) => {
        props.onSigned && props.onSigned(value);
    };

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{concent.title}</IonCardTitle>
            </IonCardHeader>

            <IonCardContent>

                <IonRow>
                    <IonCol>
                        <p>
                            {concent.content[1].data.replace("###name###", props.name)}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <p className="font-weight-bold">
                            {concent.content[2].data.replace("###name###", props.name)}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[3].data}
                        </p>
                        <p className="concent-label-value">
                            {props.name}
                        </p>

                    </IonCol>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[4].data}
                        </p>
                        <ApplySign
                            buttonText = {language && language == "Spanish" ? "Firma" :  "Sign"}
                            signed={props.signed}
                            signature={props.signature}
                            onSigned={(value) => onSigned(value)} />

                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="6">
                        <p className="concent-label">
                            {concent.content[5].data}
                        </p>
                        <p className="concent-label-value">
                            {(new Date()).toDateString()}
                        </p>

                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    );
}

export default Disclaimer;